module.exports = __webpack_public_path__ + "static/media/006-woman-1.c56185f6.svg";